import { FunctionComponent, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext, { CurrentUser } from 'src/AppContext';
import { isGmgAdminRole, isMemberRole, isOrganizationLevelAdminRole } from 'src/role';
import { ROUTES, organizationPaths } from 'src/routes';
import { getJoinOrganizationPagePath } from './joinOrganization/JoinOrganizationPage';

const Navigator: FunctionComponent<{}> = () => {
    const context = useContext(AppContext);
    const navigate = useNavigate();

    const navigateUser = (user: CurrentUser) => {
        if (user.orgIdFromInvitation) {
            // We can inject the user ID from the token here as we are already sure that the user is logged in.
            // The user ID from the invitation email is only relevant if the user has not signed up yet.
            navigate(getJoinOrganizationPagePath(user.userId, user.orgIdFromInvitation, user.orgNameFromInvitation));
            return;
        }

        if (!user.orgId) {
            navigate(ROUTES.userWithoutOrg);
            return;
        }

        if (isMemberRole(user.role)) {
            navigate(ROUTES.profile);
            return;
        }

        if (isOrganizationLevelAdminRole(user.role)) {
            navigate(organizationPaths.root(user.orgId));
            return;
        }

        if (isGmgAdminRole(user.role)) {
            navigate(ROUTES.organizations);
        }

        // TODO: define what we do if the user does not have role/orgID
    };

    // Redirect user to a page the user has access to based on the user role.
    useEffect(() => {
        if (context.user === undefined) return;

        navigateUser(context.user);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.user]);

    return (null);
};

export default Navigator;
